"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailDocumentPdf = AssetDetailDocumentPdf;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const ReactPdf_1 = require("@src/components/modules/global/ReactPdf");
const elements_1 = require("@src/components/elements");
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const AssetDetailDocument_style_1 = require("./AssetDetailDocument.style");
const AssetDetailDocument_1 = require("./AssetDetailDocument");
const AssetDetailDocumentPdf_style_1 = require("./AssetDetailDocumentPdf.style");
function AssetDetailDocumentPdf({ url }) {
    const [pageCount, setPageCount] = react_1.default.useState(1);
    const [hasError, setHasError] = react_1.default.useState(false);
    const [isLoading, setIsLoading] = react_1.default.useState(true);
    const handleLoadSuccess = pdf => {
        setPageCount(pdf.numPages);
        setIsLoading(false);
    };
    const handlePdfError = err => {
        console.error(err);
        setHasError(true);
    };
    return ((0, jsx_runtime_1.jsx)(AssetDetailDocumentPdf_style_1.PDFDocumentContainer, { showGrayBackground: !hasError && !isLoading, children: (0, jsx_runtime_1.jsx)(ReactPdf_1.Document, { file: url, loading: (0, jsx_runtime_1.jsx)(elements_1.Spinner, { size: "large" }), onLoadSuccess: handleLoadSuccess, error: (0, jsx_runtime_1.jsxs)(AssetDetailDocument_style_1.AssetDetailDocumentIconContainer, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "assets.document_cannot_be_displayed" }), (0, jsx_runtime_1.jsx)(icons_1.FilePdfOutlined, { style: AssetDetailDocument_1.DOCUMENT_FILE_ICON_STYLES })] }), onLoadError: handlePdfError, onSourceError: handlePdfError, children: new Array(pageCount).fill(null).map((_, pageIndex) => ((0, jsx_runtime_1.jsx)(ReactPdf_1.Page, { pageIndex: pageIndex, width: 1000 }, pageIndex))) }) }));
}
